import React from "react"
import ContactUsSection from "../../Sections/ContactUsSection/Content"
const ContactUsPage = () => {
    return (
      <ContactUsSection/>
    )
}
export default ContactUsPage